import { RegularPresentAcceptActivityPage } from "@/features/regular-document/pages/acceptance-activity-document/RegularPresentAcceptActivity";

const RegularPresentAcceptanceActivity = () => {
  return <RegularPresentAcceptActivityPage />;
};

export default RegularPresentAcceptanceActivity;
